import { render } from "./AdminTnc.vue?vue&type=template&id=a52055e4&lang=true"
import script from "./AdminTnc.vue?vue&type=script&lang=js"
export * from "./AdminTnc.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__